<template>
  <div id="ssr-page" class="ssr-page official-support-page">
    <transition :name="transitionName">
      <van-loading v-if="visibleLoading" class="loading" size="48" />
      <keep-alive :include="['WorkHome', 'WorkFaqList']" v-else>
        <router-view></router-view>
      </keep-alive>
    </transition>
    <UpdateVersionPopup
      v-bind:visible.sync="showUpdateVersionPopup"
      :languages="languages"
    ></UpdateVersionPopup>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Hammer from 'hammerjs';
import globalConfig from '@utiles/globalConfig';
import { judgeIsSameMainHost, isFn, getPageLoadType } from '@utiles/index';
import { GET_SKIN, SET_SUPPORT_SKIN } from '@store/sdkSkin';
import { SET_LANG } from '@store/officialSupport';
import { isReviewMode } from '@store/languages';
import iframeMessage from '@mixins/officialSupport/iframeMessage';
import { updateCommonParamsInfo } from '@plugins/biPoint/commonParam';
import { clickButton } from '@plugins/biPoint/_configOfficialSupport';
import { MAIN_HOST } from '@store/ultile';
import UpdateVersionPopup from '@components/officialSupport/UpdateVersionPopup.vue';
import { SET_SHOW_UPDATE_VERSION_POPUP } from '@store/officialSupport';
export default {
  mixins: [iframeMessage],
  data() {
    return {
      transitionName: '',
      hammer: null,
      visibleLoading: true,
      preloadImgSrcArr: [
        require('@assets/image/officialSupport/face-0.png'),
        require('@assets/image/officialSupport/face-1.png'),
        require('@assets/image/officialSupport/face-2.png'),
        require('@assets/image/officialSupport/face-3.png'),
        require('@assets/image/officialSupport/face-4.png')
      ]
    };
  },
  computed: {
    ...mapState({
      urlParams: state => state.urlParams,
      curLang: state => state.curLang,
      langList: state => state.langList,
      faqSiteName: state => state.faqSiteName,
      supportLang: state => state.supportLang,
      defaultLang: state => state.defaultLang,
      isLogin: state => state.isLogin,
      languages: state => state.languages
    }),
    ...mapGetters(['canSelectGameInfo', 'hasFaqClassList', 'hasWorkTempList']),
    needJumpListPage() {
      return [
        'workhome',
        'workfaqlist',
        'workfaqdetail',
        'worksearch',
        'worktemp',
        'root'
      ].includes(this.$route.name);
    },
    showUpdateVersionPopup: {
      get() {
        return this.$store.state.showUpdateVersionPopup;
      },
      set(value) {
        this.$store.commit(SET_SHOW_UPDATE_VERSION_POPUP, value);
      }
    }
  },
  beforeCreate() {
    // TOTO:这几个有什么用
    globalConfig.setRouterQuery(this.$route.query);
    globalConfig.setRoute(this.$route);
    globalConfig.init();

    globalConfig.storeEntryParams();
  },
  async created() {
    updateCommonParamsInfo({
      loginAccount: this.urlParams?.loginAccount || '',
      uid: this.urlParams?.uid || '',
      gameId: this.urlParams?.gameId || '',
      serverId: this.urlParams?.serverId || '',
      roleId: this.urlParams?.roleId || '',
      roleName: this.urlParams?.roleName || '',
      e_info: this.urlParams?.e_info || '',
      packageName: this.urlParams?.packageName || '',
      devicePlate: this.urlParams?.devicePlate || '',
      cid: this.urlParams?.cid || '',
      scid: this.urlParams?.scid || '',
      language:
        this.curLang ||
        this.urlParams?.language ||
        globalConfig.getHrefParam('language') ||
        ''
    });
    await this.initPage();
    await this.$store.dispatch(GET_SKIN, SET_SUPPORT_SKIN);
    if (this.urlParams?.gameId) {
      await this.getFaqConfig();
      await this.getWorkTempConfig();
      await this.$store.dispatch('checkJumpAiBot', {
        game_id: this.urlParams?.gameId,
        server_id: this.urlParams?.serverId
      });
      this.checkJumpListPage();
    } else {
      if (this.needJumpListPage) {
        this.replaceToListPage();
      }
    }
    this.visibleLoading = false;
    this.preloadImg();
    globalConfig.addEvenListener(this.listenerHandle, 'message');
  },
  watch: {
    // 根据meta层级设置页面切换过渡动画
    $route(to, from) {
      const toIndex = to.meta.index || 0;
      const fromIndex = from.meta.index || 0;
      const isFromPageUp = from.meta.pageUp && from.meta.pageUp === 1;
      const isToPageUp = to.meta.pageUp && to.meta.pageUp === 1;
      if (!toIndex || !fromIndex) {
        this.transitionName = '';
        return;
      }
      if (isToPageUp) {
        this.transitionName = 'page-up';
      } else if (isFromPageUp) {
        this.transitionName = 'page-down';
      } else {
        this.transitionName =
          toIndex < fromIndex ? 'slide-right' : 'slide-left';
      }
    },
    curLang: {
      handler(newVal) {
        this.postMessageToParent('setLang', newVal);
      },
      immediate: true
    },
    langList: {
      handler(newVal) {
        this.postMessageToParent('setLangList', newVal);
      },
      immediate: true
    },
    supportLang: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.postMessageToParent('setLangList', newVal);
          if (!isReviewMode() && !newVal[this.curLang]) {
            this.$store.commit(SET_LANG, this.defaultLang);
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'checkLogin',
      'getEmail',
      'getUserInfo',
      'getFaqSiteName',
      'getFaqClassList',
      'getWorkTempList'
    ]),
    listenerHandle(e) {
      const evt = e || event;
      const data = evt?.data;
      const ACTION_MAP = {
        changeLang: this.changeLang
      };
      const action = data?.action;
      const value = data?.value;
      const handleFn = ACTION_MAP[action];
      if (
        handleFn &&
        judgeIsSameMainHost(evt.origin, window.location.origin) &&
        isFn(handleFn)
      ) {
        handleFn(value);
      }
    },
    changeLang(value) {
      this.$store.commit(SET_LANG, value);
      clickButton({
        btnName: 'clickChooseLang',
        otherParams: {
          lang: value
        }
      });
    },
    preloadImg() {
      for (let i = 0, len = this.preloadImgSrcArr.length; i < len; i++) {
        try {
          const img = new Image();
          img.src = this.preloadImgSrcArr[i];
        } catch (e) {
          console.error(e);
        }
      }
    },
    async initPage() {
      try {
        if (!this.canSelectGameInfo) {
          this.getUserInfo();
        }
        await this.checkLogin();
        // 登录成功了才获取绑定邮箱
        await this.getEmail();
      } catch (e) {
        console.log(e);
        // 2025-02-25 张柳：通过官网访问客服中心需先登录账号，再走后续的AI分层逻辑;customFrom=website的设置位于公共脚本point中
        if (
          globalConfig.getHrefParam('customFrom').includes('website') &&
          !this.isLogin
        ) {
          window.location.href = `https://pay.${MAIN_HOST}/platform/login.html?gameId=${
            this.urlParams?.gameId || ''
          }&forward=${encodeURIComponent(window.location.href)}`;
          return;
        }
      }
    },
    // 监听页面pan手势，左滑返回上一层
    handlePanEvent() {
      // 获取页面宽度
      let width = document.body.clientWidth;
      // 半屏宽度
      let halfWidth = width / 2;
      let $contain = document.getElementById('ssr-page');
      let hammer = new Hammer($contain);
      this.hammer = hammer;
      // 根据移动的横向距离及竖项距离，计算夹角
      // 用于兼容hammerjs无法判断方向时
      // 将夹角为45度以内均当为横向滑动
      const getTanDeg = tan => {
        let result = Math.atan(tan) / (Math.PI / 180);
        result = Math.round(result);
        return result;
      };
      hammer.get('pan').set({ direction: Hammer.DIRECTION_RIGHT });
      hammer.on('panend', ev => {
        // 如果当前页面是workfaqdetail，不添加手势监听，方便需要用户选择文字复制
        if (this.$route.name === 'workfaqdetail') {
          return;
        }
        // 起始x坐标，需要在半屏以内
        let startX = ev.center.x - ev.deltaX;
        // 移动距离，需要小于半屏宽度
        let distance = ev.deltaX;
        let notDown = Math.abs(ev.deltaY) <= 50;
        let isRight =
          notDown &&
          startX <= halfWidth &&
          distance <= halfWidth &&
          ev.direction === Hammer.DIRECTION_RIGHT;
        if (ev.direction !== Hammer.DIRECTION_RIGHT) {
          // tan角度 = 对边 / 邻边
          let angle = getTanDeg(Math.abs(ev.deltaY) / ev.deltaX);
          if (angle <= 45) {
            isRight = notDown && startX <= halfWidth && distance <= halfWidth;
          }
        }
        if (isRight) {
          this.$router.back();
        }
      });
    },
    async getFaqConfig() {
      await this.getFaqSiteName();
      if (this.faqSiteName) {
        await this.getFaqClassList();
      }
    },
    async getWorkTempConfig() {
      await this.getWorkTempList();
    },
    replaceToListPage() {
      this.$router.replace('/mylist');
    },
    replaceToHomePage() {
      this.$router.replace('/workhome');
    },
    checkJumpListPage() {
      // 智能工单预览功能无需跳转
      if (
        globalConfig.getHrefParam('isReview') == 1 &&
        this.$route.name === 'worktemp'
      ) {
        return;
      }
      if (
        this.$route.name === 'root' &&
        (this.hasFaqClassList || this.hasWorkTempList)
      ) {
        this.replaceToHomePage();
        return;
      }
      if (
        this.needJumpListPage &&
        !this.hasFaqClassList &&
        !this.hasWorkTempList
      ) {
        this.replaceToListPage();
        return;
      }
      // 直接进入工单列表页，跳首页，刷新页面则不跳
      // 解决sdk写死跳mylist页的问题
      if (
        this.$route.name === 'mylist' &&
        getPageLoadType() === 'navigate' &&
        (this.hasFaqClassList || this.hasWorkTempList)
      ) {
        this.replaceToHomePage();
      }
    }
  },
  mounted() {
    if (!globalConfig.isTiktokMiniProgram()) {
      this.$nextTick(() => {
        this.handlePanEvent();
      });
    }
    if (
      globalConfig.getHrefParam('h5') == 1 &&
      globalConfig.getHrefParam('m') == 1
    ) {
      try {
        // 移动端双击禁止：主要是为了禁止放大
        document.addEventListener('dblclick', function (event) {
          event.preventDefault();
        });

        document
          .getElementById('ssr-page')
          .addEventListener('touchmove', function (e) {
            e.stopPropagation();
            // e.preventDefault(); // h5跳转工单页，移动端无法滑动，先注释掉
          });

        // 移动端快速点击禁止：主要是为了禁止放大
        var lastTouchEnd = 0;
        document.addEventListener(
          'touchend',
          function (event) {
            var now = new Date().getTime();
            if (now - lastTouchEnd <= 300) {
              event.preventDefault();
            }
            lastTouchEnd = now;
          },
          false
        );
      } catch (e) {}
    }
  },
  beforeDestroy() {
    this?.hammer?.destroy();
  },
  components: {
    UpdateVersionPopup
  }
};
</script>
<style>
html {
  width: 100%;
  height: 100%;
  overflow-x: visible !important;
  overflow-y: visible !important;
  background-color: var(--page-bgColor);
}
body {
  margin: 0;
  width: 100%;
  height: 100%;
  overflow-x: visible !important;
  overflow-y: visible !important;
}
.ssr-page {
  width: 100%;
  height: 100%;
  /* font-size: 0; */
}
</style>

<style lang="scss">
@import '@assets/scss/base.scss';
@import '@assets/scss/sdkSkin.scss';
@import '@assets/scss/animate.scss';
@import '@assets/scss/officialSupport/officialSupport.scss';
@import '@assets/scss/officialSupport/font/iconfont.scss';

.official-support-page {
  position: relative;
  overflow-x: hidden;

  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--main-color);
  }
}

.van-toast__icon {
  // 修复打包后样式被覆盖的问题
  font-size: 36px !important;
}

.van-image-preview__close-icon {
  // 修复打包后样式被覆盖的问题
  font-size: 22px !important;
}
</style>
